<div id="wrapper">
    <div id="menu-wrapper">
        <div id="menu" class="container">
            <ul>
                <li><a routerLink="/home">Home</a></li>
                <li class="current_page_item"><a routerLink="/kunst">Kunst & Cultuur</a></li>
                <li><a routerLink="/zorg">Zorg</a></li>
                <li><a routerLink="/onderwijs">Onderwijs</a></li>
                <li><a routerLink="/contact">Contact</a></li>
            </ul>
        </div>
    </div>
    <div id="banner">
    </div>
    <div id="page" class="container">
    <div id="content">
        <div class="title">
            <h2>AUXILIUM CU(LTU)RA LEVERT GELD OP</h2>
        </div>
        <p>De kunstsector is grotendeels afhankelijk van subsidies. Helaas zijn veel subsidies de afgelopen jaren gekort. De consequenties van deze bezuinigingen kunnen voor culturele ondernemingen of opleidingen voor kunst en cultuur erg ingrijpend zijn. </p>
        <p>Daarom wil je als organisatie dat de tijd (en dus het geld) op een zo efficiënt en effectieve manier wordt ingezet. AC kan de organisatie hierbij ondersteunen. Voor musea voeren we bijvoorbeeld op een centraal punt de contract(op)stelling, prijsstelling en facturatie uit. Het enige wat de werknemer hoeft te doen is de werktijden doorgeven aan AC. Omdat wij werk uit handen nemen kan het museum zich volledig richten op de inzet van de medewerker op de juiste plaats en tijd. Dit zorgt uiteindelijk voor de beste kwaliteit én minder kosten door efficiëntie.</p>
        <p>Theater, kunst en cultuur: het zit in ons bloed. Veel van onze medewerkers zijn zelf verbonden aan het theater en de kunstvoorzieningen en evenementen. Daarom voelen wij ons nauw betrokken bij deze instellingen. </p>
        <div class="title">
            <h2>ONZE FOCUS</h2>
        </div>
        <p><b>Theater en evenementen</b></p>
        <ul style="list-style-type:disc;">
            <li>Kleine, middelgrote en grote schouwburgen</li>
            <li>Vlakkevloer theaters, culturele centra en wijkcentra</li>
            <li>Expositiehallen</li>
            <li>Evenementenhallen</li>
            <li>Schooltheaters en -zalen</li>
        </ul>
        <p><b>Musea</b></p>
        <ul style="list-style-type:disc;">
            <li>Rondleiders</li>
            <li>Flexibele horeca inzet</li>
            <li>Beveiliging</li>
            <li>Baliemedewerkers</li>
            <li>Informatiemedewerkers</li>
        </ul>
        <p>De opdrachtnemer kan daardoor het werk naar behoren uitvoeren en hoeft alleen nog maar werktijden door te geven aan AC. Ook dit komt weer ten goede aan de kwaliteit van het uitvoerende werk.</p>
    </div>
</div>
</div>
<div id="footer-wrapper">
    <div id="footer" class="container">
        <div id="box1">
            <h2>Contact</h2>
            <p>Auxilium Cu(ltu)ra BV, Vliet Noordzijde 49 2231 GP Rijnsburg</p>
            <p>Email: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;info@auxiliumcultura.nl</p>
            <p>Phone: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;06 - 53 43 89 00</p>
            <p>Phone: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;06 – 22 50 70 90</p>
        </div>
    </div>
</div>
<div id="copyright-wrapper" class="container">
    <div id="copyright" class="container">
        <p><a routerLink="/copyright">Terms and Conditions</a></p>
    </div>
</div>